import { fetchTextNotification, downloadTextNotificationCsv } from '../services/napi';
import {
  TEXT_NOTIFICATION_FETCH_SUCCESS,
  DOWNLOAD_TEXT_NOTIFICATION_SUCCESS
} from '../constant/actionType';

export function fetchTextNotifications() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await fetchTextNotification(projectId);
      dispatch({
        data: response.data.messages,
        type: TEXT_NOTIFICATION_FETCH_SUCCESS
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function downloadTextNotification() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await downloadTextNotificationCsv(projectId);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `textNotification.csv`);
    document.body.appendChild(link);
    link.click();

    dispatch({
      data: response.data,
      type: DOWNLOAD_TEXT_NOTIFICATION_SUCCESS
    });
  };
}
